import Landing from "@/pages/Landing";
export default function USLanding() {
  return <Landing marketKey="us" showVSL />;
}
